"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ConectaConTuEnergia() {
  return <section id="conecta-con-tu-energia" className="relative overflow-hidden bg-background py-14 md:py-18 lg:py-20">
      <style dangerouslySetInnerHTML={{
      __html: `
            @keyframes shimmer {
              100% { transform: translateX(100%); }
            }
            .animate-shimmer {
              animation: shimmer 2s infinite;
            }
          `
    }} />

      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,_var(--color-accent)_0%,_transparent_50%)] opacity-20" />

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="flex max-w-2xl flex-col items-start">
            <div className="mb-6 h-[2px] w-16 bg-ring opacity-80" />

            <h1 className="mb-5 max-w-[14ch] font-serif text-4xl leading-[1.04] tracking-tight text-foreground sm:text-5xl lg:text-[4.1rem] xl:text-[4.6rem]">
              Objetos con intención para tu altar, tu espacio y tu transformación
            </h1>

            <p className="mb-8 max-w-xl font-sans text-base leading-relaxed text-muted-foreground sm:text-lg lg:text-xl">
              Piezas simbólicas creadas para acompañar procesos de protección,
              amor, claridad, abundancia y conexión interior.
            </p>

            <Link to="/tienda">
              <Button size="lg" className="group relative h-12 overflow-hidden rounded-xl border border-transparent bg-primary px-8 text-base font-medium text-primary-foreground transition-all duration-300 hover:border-ring/50 hover:opacity-95">
                <span className="relative z-10">Ver Tienda</span>
                <div className="absolute inset-0 z-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-shimmer" />
              </Button>
            </Link>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 top-1/2 h-[75%] w-[75%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-chart-2/20 blur-[90px]" />

            <div className="relative overflow-hidden rounded-2xl shadow-lg">
              <img src="https://nuna-atelier.com/wp-content/uploads/2026/03/cropped-generic_crystal_ritual_featured.webp" alt="Objetos rituales y piezas con intención" className="h-[320px] w-full object-cover sm:h-[420px] lg:h-[520px]" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}